import {Cell} from "react-table";
import React from "react";

/**
 * Rendert die "Anhänge"-Tabellen-Zelle für das Einreichungslisting
 *
 * @param cell
 * @constructor
 */
const AttachmentColumn: (cell: Cell) => JSX.Element | null = (cell: Cell) => {
    if (cell.row.values.attachments > 0) {
        return (
            <span className='badge badge-attachment'>
                    {cell.row.values.attachments}<i className="fa fa-paperclip"/>
                </span>
        );
    }
    return null;
}

export default AttachmentColumn;